<template>
  <div>
    <div id="container-table">
      <ts-loading-banner :loading="getting_pre_invoice">
        <table class="table table-hover ui-table">
          <thead>
            <tr>
              <th>{{ $t('invoice.preInvoiceNumber') }}</th>
              <th>{{ $t('invoice.student') }}</th>
              <th>{{ $t('invoice.academicInfo') }}</th>
              <th class="text-center">{{ $t('invoice.amount') }}</th>
            </tr>
            <tr>
              <th colspan="9">
                <input
                  v-model="search"
                  type="text"
                  class="form-control"
                  :placeholder="$t('invoice.typeSearch')"
                />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(pre, index) in pre_invoice_list"
              :key="index"
              @dblclick="selected(pre)"
            >
              <td>
                <p
                  class="text-primary"
                  v-tooltip="$t('invoice.preInvoiceNumber')"
                >
                  <i class="fas fa-file-invoice mr-2"></i>
                  <strong>{{ pre.pre_invoice_number }}</strong>
                </p>
                <p v-tooltip="$t('invoice.invoiceDate')">
                  <i class="fa fa-clock mr-2"></i>
                  {{ pre.pre_invoice_date }}
                </p>
              </td>
              <td>
                <p class="text-primary" v-tooltip="$t('invoice.studentName')">
                  <i class="fa fa-user mr-2"></i>
                  <strong>{{ pre.student.full_name_en }}</strong>
                </p>
                <p v-tooltip="$t('invoice.studentId')">
                  <i class="far fa-id-card mr-2"></i>
                  {{ pre.student.card_number }}
                </p>
                <p
                  v-if="pre.student.phone"
                  v-tooltip="$t('invoice.phoneNumber')"
                >
                  <i class="fa fa-phone mr-2"></i>
                  {{ pre.student.phone }}
                </p>
                <p v-tooltip="$t('invoice.sex')">
                  <i class="fa fa-venus-mars mr-2"></i>
                  {{ pre.student.gender }}
                </p>
              </td>
              <td>
                <p v-tooltip="$t('invoice.subProgram')">
                  <i class="fa fa-book-open mr-2"></i>
                  {{ pre.sub_program.acps_name_foreign }}
                </p>
                <p v-tooltip="$t('invoice.grade')" class="text-info">
                  <i class="fa fa-layer-group mr-2"></i>
                  {{ pre.grade.grade_name_foreign }}
                </p>
                <p v-tooltip="$t('invoice.studyTime')" class="text-warning">
                  <i class="fa fa-clock mr-2"></i>
                  {{ pre.study_time }}
                </p>
              </td>
              <td class="text-center">{{ pre.amount_due }}</td>
            </tr>
          </tbody>
        </table>
      </ts-loading-banner>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'preInvoiceList',
  data() {
    return {
      getting_pre_invoice: false,
      search: null,
      pre_invoice_list: []
    }
  },
  computed: {
    is_external() {
      return this.$store.state.authUser.is_external
    }
  },
  created() {},
  methods: {
    ...mapActions('invoice', ['getPreInvoice']),
    fetchPreInvoice() {
      this.getting_pre_invoice = true
      this.getPreInvoice({
        search: this.search,
        perPage: -1
      })
        .then(response => {
          this.pre_invoice_list = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.getting_pre_invoice = false
        })
    },
    selected(row) {
      this.$emit('selected', row)
    }
  },
  watch: {
    search: debounce(function(value) {
      if (value !== null || value !== '') {
        this.fetchPreInvoice()
      }
      this.pre_invoice_list = []
    }, 600),
    is_external: debounce(function() {
      this.fetchPreInvoice()
    }, 500)
  }
}
</script>

<style lang="css" scoped>
#container-table {
  max-height: 35vh;
	height: 30vh;
  overflow: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  white-space: nowrap;
}

.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  /* z-index: 999; */
  padding: 5px 15px;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
  cursor: pointer;
  font-size: 12px !important;
}
</style>
